import {ref, unRef, shallowRef, computed, onMounted} from 'vue'
import {_get} from '@/actions.js'
import {isInf} from '@/comp/useCruise.js'

export default function useCruiseBook(data) {
//console.error('useCruiseBook')
//    return {PriceTree: [1], CabinTree: [], DeckOptions: []}
    if (!data) {// заполняю ключи для механизма реактивности vue2
        return useCruiseBook0()
    }

    let { roomDetail: {meta, decks, groups, rooms} } = data

    if (meta.empty) {// 
        return useCruiseBook0()
    }

    const groupMap = new Map( groups.map( g => [ g.id, g  ] ) )
    const deckMap = new Map( decks.map( g => [ g.id, g  ] ) )

    const getCabinSet = ( group_id, deck_id ) => {
        group_id = parseInt(group_id, 10)
        const g = groupMap.get( group_id )
        let { id, name, description, photos, decks:decks_old, prices } = g
        let baseprice = null
        if (meta.hasPrice) {
            baseprice = prices.filter( 
                p => p.deck_id === deck_id && p.v[0] 
            ).at(0)
        }
        let decks = decks_old.filter( d => d.id === deck_id )
        return { id, name, description, photos, decks, baseprice}
    }


    const {CabinTree, a, b, c, CabinMap} = rooms.reduce( (akk, room ) => {
        let { id, name, acc, deck_id, group_id, availability } = room
        group_id = parseInt(group_id, 10)
        let CabinSet = getCabinSet( group_id, deck_id )
        let deck = deckMap.get( deck_id )

        const idCabinSet = `${group_id}.${deck_id}`

        let bookstatus = null
        if (meta.hasPrice) {
            // подружим vodohod и infoflot
            bookstatus = { status: availability ? 0 : 4 }
        }
        let Cabin = { id, name, acc, deck, bookstatus }

        if (!meta.hasPrice || CabinSet.baseprice) {// игнорируем если нет цены, когда быть должна
            let cabinCabinSet = { Cabin, CabinSet}
            akk.CabinTree.push( cabinCabinSet )
            akk.CabinMap[ id ] = cabinCabinSet

            akk.a.set( idCabinSet, CabinSet  )
            let Cabs = akk.b.get( idCabinSet ) || []
            Cabs.push( Cabin )
            akk.b.set( idCabinSet, Cabs)

            if (meta.hasPrice && availability) {
                let tCabs = akk.c.get( idCabinSet ) || []
                tCabs.push( Cabin )
                akk.c.set( idCabinSet, tCabs)
            }
        }

        return akk
    }, {
        CabinTree: [], // список Cabin CabinSet
        a: new Map, // станет PriceTree
        b: new Map, // каюты в категории
        c: new Map, // Свободные-Каюты в категории
        CabinMap: {},
    } )

    let PriceTree = []
    a.forEach( (CabinSet, idCabinSet) => {
        const Cabins = b.get( idCabinSet ) || []
        const CabinsFree = c.get( idCabinSet ) || []
        PriceTree.push( { CabinSet, Cabins, CabinsFree } )
    } )

    if (meta.hasPrice) {
        PriceTree = PriceTree.sort( (a,b) => {
            return a.CabinSet.baseprice.v[0] - b.CabinSet.baseprice.v[0]
        } ) 
    }


    return {
        PriceTree, CabinTree, CabinMap,
    }
}

const useCruiseBook0 = () => {
    return {
        PriceTree: null, CabinTree: [], CabinMap: null,
    }
}

// const accHash = par => `${par.all},${par.main},${par.sum},${par.cmp}`
function gtcmp( a, cmp, b ) {
    let ret=true
    if ('eq'===cmp) {
        ret =  a===b
    } else if ('geq' === cmp) {
        ret =  b >= a
    }
//console.log('gtcmp', a, cmp, b  )        
    return ret
}
function acc_cmp( { all, main, sum, cmp }, {main:base, additional:addi} ) {
    let ret=true
    if (!all) {
        if (main) {
            ret = gtcmp( main,  cmp, base  )
        } else if (sum) {
            ret = gtcmp(  sum, cmp, base+addi )
        }
    }
    return ret
}

export const isFree = ({bookstatus}) => bookstatus && 0 === bookstatus.status


function cmp( Cabin, CabinSet, CabinFilter, isBooked ) {// используется только когда есть цены
    let { deck_id, cset_id,  acc_num, free, book} = CabinFilter
    let deck_flt = !deck_id || Cabin.deck.id === deck_id
    let cset_flt = !cset_id || CabinSet.id === cset_id
    let acc_flt = acc_cmp( acc_num, Cabin.acc )
    let free_flt = !free || isFree( Cabin )
// фильтр book - игнорит остальные фильтры    
    return book ? isBooked : deck_flt && cset_flt && acc_flt && free_flt
}

export function useFiltered(CabinTree, BookCabinIds) {
    const CabinTreeFiltered =  (CabinFilter) => {
//console.log('CabinTreeFiltered', 'CabinFilter', CabinFilter)        
        return CabinTree.map( ob => {
            let isBooked = BookCabinIds.includes(ob.Cabin.id)
            return {...ob, isBooked}
        } ).filter( ({Cabin, CabinSet, isBooked}) => cmp( Cabin, CabinSet, CabinFilter, isBooked ) )
    }
    return {CabinTreeFiltered}
}


export const isCabinFree = ({Cabin}) => isFree( Cabin )

